var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.0286 11.4314C22.1936 12.1267 22.2017 13.8113 21.0435 14.5179L3.7439 25.072C2.54607 25.8028 1.00941 24.9451 1.00262 23.542L0.901291 2.60173C0.894502 1.19861 2.4228 0.326081 3.62764 1.04522L21.0286 11.4314Z","fill":"#0F1D74"}));
}

PlayIconInline.defaultProps = {"width":"22","height":"26","viewBox":"0 0 22 26","fill":"none"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
